import validations from 'utils/validation';
import * as Yup from 'yup';
export interface IInternalUserInput {
  id?: string;
  first_name: string;
  middle_name: string;
  last_name: string;
  mobile_number: string;
  email: string;
  role: string;
  bank_name: string;
  bank_account_holder: string;
  bank_account_number: string;
  bank_branch: string;
  bank_address: string;
  pan_number: string;

  user_type?: string;
}

export const internalUserInitialValues: IInternalUserInput = {
  first_name: '',
  middle_name: '',
  last_name: '',
  email: '',
  mobile_number: '',
  role: '',
  bank_name: '',
  bank_account_holder: '',
  bank_account_number: '',
  bank_branch: '',
  bank_address: '',
  pan_number:''
};

export const internalUserSchemaValidations = Yup.object().shape({
  first_name: Yup.string().required('First Name is required'),
  middle_name: Yup.string().nullable(),
  last_name: Yup.string().required('Last Name is required'),

  email: Yup.string().email('Invalid email').required('Email is required'),

  mobile_number: Yup.string()
    .matches(validations.phone.regex, validations.phone.message)
    .required('Mobile Number is required'),

  role: Yup.string().required('Role is required'),

  bank_name: Yup.string().nullable(),
  // .when('role', {
  //   is: 'external',
  //   then: (schema) => schema.required('Bank Name is required'),
  //   otherwise: (schema) => schema.nullable(),
  // }),

  bank_account_holder: Yup.string().nullable(),
  // .when('role', {
  //   is: 'external',
  //   then: (schema) => schema.required('Account Holder Name is required'),
  //   otherwise: (schema) => schema.nullable(),
  // }),

  bank_account_number: Yup.string().nullable(),
  // .when('role', {
  //   is: 'external',
  //   then: (schema) => schema.required('Account Number is required'),
  //   otherwise: (schema) => schema.nullable(),
  // }),

  bank_branch: Yup.string().nullable(),
  // .when('role', {
  //   is: 'external',
  //   then: (schema) => schema.required('Branch is required'),
  //   otherwise: (schema) => schema.nullable(),
  // }),

  bank_address: Yup.string().nullable(),
  
  // .when('role', {
  //   is: 'external',
  //   then: (schema) => schema.required('Bank Address is required'),
  //   otherwise: (schema) => schema.nullable(),
  // }),

  pan_number: Yup.string().nullable(),
  
  // .when('role',{
  //   is:'external',
  //   then:(schema)=>schema.required("PAN Number is required"),
  //   otherwise:(schema)=>schema.nullable()
  // }) ,
});